import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  resources: {
    en: {
      translation: require('./locales/en/translation.json')
    },
    si: {
      translation: require('./locales/si/translation.json')
    }
  },
  interpolation: {
    escapeValue: false
  }
});

export default i18n;